import React from 'react';

import WarningModal from '@3.0/Modals/WarningModal/WarningModal';
import { SUBMIT_BUTTON_LABELS } from '@3.0/Buttons';

type TProps = {
  onClose?: () => void;
  onConfirm: () => void;
};

const TEXT_STRINGS = {
  primary: 'Starting Full Data Ingestion',
  secondary: (
    <span>
      This action will <b>delete all</b> current data for the data sources configured and then
      ingest each data source. This will temporarily make all questions and visualizations built off
      of them unusable until the ingestion is done. This could take a while depending on the size of
      the data
    </span>
  ),
  confirm: SUBMIT_BUTTON_LABELS.continue,
};

function VerifyStartIngestionModal({ onClose = () => {}, onConfirm = () => {} }: TProps) {
  return (
    <WarningModal
      text={{
        messages: {
          primary: TEXT_STRINGS.primary,
          secondary: TEXT_STRINGS.secondary,
        },
        buttons: {
          primary: TEXT_STRINGS.confirm,
        },
      }}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
}

export default VerifyStartIngestionModal;
